import React from 'react';
import DOMAIN_TITLE_MAP from '../../resources/title';
import DOMAIN_FAVICON_MAP from '../../resources/favicon';

function DomainHead() {
  React.useEffect(function setHead() {
    try {
      var host = window.location.hostname;

      // — Title
      var title = DOMAIN_TITLE_MAP[host] || DOMAIN_TITLE_MAP.default;
      document.title = title;

      // — Favicon
      var favicon = DOMAIN_FAVICON_MAP[host] || DOMAIN_FAVICON_MAP.default;
      if (favicon) {
        var link =
          document.querySelector("link[rel~='icon']") ||
          document.createElement('link');
        link.rel = 'icon';
        link.href = favicon;
        // bazı durumlarda type set etmek isteyebilirsin: link.type = 'image/png';
        document.head.appendChild(link);
      }
    } catch (e) {
      // hata varsa konsola yaz, uygulama çalışmaya devam etsin
      // console.warn("DomainHead error:", e);
    }
    // cleanup gerekmez
    return;
  }, []);

  // DOM'a render edilmesi gerekmez
  return null;
}

export default DomainHead;
